import { isEmpty } from 'lodash-es';
import { useCollectionPageContext } from '../../hooks/useCollectionPageContext';
import { FilterType } from '../../hooks/types';
import Filter from './Filter';
import PriceFilter from './PriceFilter';
import SelectedFilters from './SelectedFilters';

const Filters = () => {
  const {
    filters,
    selectedFilters,
    fixedFilters,
    type: collectionPageType,
  } = useCollectionPageContext();

  const variants = filters?.variants ?? [];

  const isFixedFilter = (id: string, option: string, type: FilterType) => {
    if (type === FilterType.BRAND) {
      // If there's a fixed brandIds filter, we hide it
      if (fixedFilters.brandIds?.includes(id)) {
        return true;
      }
    }

    if (type === FilterType.CATEGORY) {
      // If there's a fixed categoryIds filter, we hide it
      if (fixedFilters.categoryIds?.includes(id)) {
        return true;
      }
    }

    return false;
  };

  return (
    <>
      <SelectedFilters />
      <PriceFilter />
      {/* Categories Filter */}
      {filters.categories && filters.categories.length > 1 && (
        <Filter
          key="categories"
          options={filters.categories.filter(
            (o) => !isFixedFilter(o.id, o.name, FilterType.CATEGORY),
          )}
          type={FilterType.CATEGORY}
          name="Category"
          expanded={
            !isEmpty(selectedFilters?.categories) ||
            collectionPageType === 'MS_CATALOG_DEALS'
          }
        />
      )}
      {/* Brands Filter */}
      {filters.brands && filters.brands.length > 1 && (
        <Filter
          key="brands"
          options={filters.brands.filter(
            (o) => !isFixedFilter(o.id, o.name, FilterType.BRAND),
          )}
          type={FilterType.BRAND}
          name="Brand"
          expanded={
            !isEmpty(selectedFilters?.brands) ||
            collectionPageType === 'MS_CATALOG_DEALS'
          }
        />
      )}
      {variants.map((variant) => {
        if (
          [
            'Cellular Network',
            'Network Provider',
            'Cellular Status',
            'Carrier',
          ].includes(variant.name)
        ) {
          return null;
        }

        return (
          <Filter
            key={variant.id}
            name={variant.name}
            slug={variant.slug}
            options={variant.values.map((v) => ({
              id: variant.id,
              name: v.value,
              displayValue: v.displayValue,
            }))}
            type={FilterType.VARIANT}
            expanded={Object.keys(selectedFilters?.variants ?? {}).includes(
              variant.id,
            )}
          />
        );
      })}
    </>
  );
};

export default Filters;
